import React, { Component } from 'react';

import { Container } from './styles.js';

import ModalCategorias from './modalCategorias';
import ModalProdutos from './modalProdutos';

import BannerDesktop from '../../../assets/banner_promo/combos/desktop/combos@3x.png';
import BannerMobile from '../../../assets/banner_promo/combos/mobile/combos@3x.png';
import prodNoImg from '../../../assets/produtos/produto_sem-imagem.svg'

import Burguer from '../../../assets/emojis/combo/combo@3x.png';
import Paper from '../../../assets/emojis/papel/papel@3x.png';

import {IoMdClose} from 'react-icons/io';
import {FiChevronDown, FiTrash2} from 'react-icons/fi';

import api from '../../../services/api';
import moment from 'moment';
import Modal from 'react-modal';

export default class ModalCombos extends Component {

    constructor(props) {
        super(props);
        this.state = {
            token: props.token,
            loaded: false,
            windowWidth: window.innerWidth,
            combos: [],
            categorias: [],
            produtos: [],
            isSelecting: false,
            categoriaClass: 'div-input',
            produtoClass: 'div-input',
            categoria: '',
            produto: '',
            categoriaId: null,
            produtoId: null,
            modalCategorias: false,
            modalProdutos: false
        }
    }

    async getProdutos() {
        try {
            await api.get('api/produtos/listar', {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(res => {
                console.log(res);
                this.setState({
                    categorias: res.data,
                });
            }).catch(async e => {
                console.log({e: e})
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                        await localStorage.removeItem('@jwt');
                        await localStorage.removeItem('@user');
                        await localStorage.removeItem('@rest');
                        await localStorage.removeItem('@uf');
                        await localStorage.removeItem('@internal');
                        await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            })
        } catch (e) {
            console.log(e);
        }
    }

    getNovidades() {
        try {
            api.get("api/combos/listar", {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            })
                .then(res => {
                    this.setState({
                        combos: res.data.combos,
                        loaded: true,
                    })
                })
                .catch(e => {
                    console.log(e);
                    this.props.error();
                })
        } catch (e) {
            console.log(e);
        }
    }

    postNovidades() {
        try {
            api.post("api/combos/criar", {
                produto_id: this.state.produtoId
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            })
                .then(res => {
                    console.log(res.data);
                    this.props.success();
                    this.getNovidades();
                    this.setState({
                        isSelecting: false,
                        categoria: '',
                        produto: '',
                        categoriaId: null,
                        produtoId: null,
                    })
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status === 400) {
                        this.props.customError(e.response.data.error);
                    } else {
                        this.props.error();
                    }
                })
        } catch (e) {
            console.log(e);
        }
    }

    delNovidades(id) {
        try {
            api.delete(`api/combos/deletar/${id}`, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            })
                .then(res => {
                    console.log(res.data);
                    this.props.success();
                    this.getNovidades();
                })
                .catch(e => {
                    console.log(e);
                    this.props.error();
                })
        } catch (e) {
            console.log(e);
        }
    }

    createNovidade() {
        this.setState({
            isSelecting: true
        });
        this.getProdutos();
    }

    componentDidMount() {
        this.getNovidades();
        window.addEventListener("resize", this.handleResize);
    }

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
    }

    controllerModalCateg() {
        const state = this.state.modalCategorias;
        this.setState({
            modalCategorias: !state
        })
    }
    
    controllerModalProd() {
        const state = this.state.modalProdutos;
        this.setState({
            modalProdutos: !state
        })
    }

    setCategoria(id, nome) {
        const array = this.state.categorias;
        this.setState({
            categoriaId: id,
            categoria: nome,
            produtoId: null,
            produto: '',
        });
        for (let i = 0; i < array.length; i++) {
            if (array[i].id === id) {
                this.setState({
                    produtos: array[i].produtos
                })
            }
        }
        this.controllerModalCateg();
    }

    setProduto(id, nome) {
        this.setState({
            produtoId: id,
            produto: nome
        });
        this.controllerModalProd();
    }

    render() {
        return(
            <Container>
                <Modal
                    isOpen={this.state.modalCategorias}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModalCateg()}
                    closeModal={() => this.controllerModalCateg()}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={this.state.windowWidth > 930  ? entrada : mobile}
                    contentLabel="Modal"
                    >
                        <ModalCategorias
                            categorias={this.state.categorias}
                            selecionar={(id, nome) => this.setCategoria(id, nome)}
                            closeModal={() => this.controllerModalCateg()}/>
                </Modal>
                <Modal
                    isOpen={this.state.modalProdutos}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModalProd()}
                    closeModal={() => this.controllerModalProd()}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={this.state.windowWidth > 930  ? entrada : mobile}
                    contentLabel="Modal"
                    >
                        <ModalProdutos
                            produtos={this.state.produtos}
                            selecionar={(id, nome) => this.setProduto(id, nome)}
                            closeModal={() => this.controllerModalProd(this.state.modalProdutos)}/>
                </Modal>
                <div className="header">
                    <img 
                        className="banner"
                        src={BannerDesktop} 
                        alt="Banner Combos" 
                    />
                        <button onClick={() => this.props.closeModal()}>
                            <IoMdClose className="icon"/>
                        </button>

                    <div className="content">

                        <img src={Burguer} alt="Combos" />

                        <h1>Cadastre seu 
                            <p>combo de produtos</p>
                        </h1>

                        <h5><span>Combine seus produtos</span> e crie combos
                        <p>para <span>aumentar suas vendas.</span></p></h5>
                    </div>
                </div>

                {this.state.loaded
                    && (this.state.isSelecting
                            ? (
                                <div className="configurar">
                                    <img src={Paper} alt="" /> 
        
                                    <h1>Vamos configurar seu <p>combo de produtos</p></h1>
        
                                    <div className="inputs">
                                        <div className={this.state.categoriaClass} onClick={() => this.controllerModalCateg()}>
                                                <input
                                                    value={this.state.categoria}
                                                    name="valor"
                                                    type="text"
                                                    required
                                                    style={{
                                                        caretColor: 'transparent'
                                                    }}
                                                    onChange={() => {}}
                                                    />
                                                <label htmlFor="" className="label-name">
                                                    <span className="content-name">Categoria</span>
                                                </label>
                                                    <button className="botao-olho">
                                                        <FiChevronDown size={22} color="#1c0506" className="i" />
                                                    </button>
                                        </div>
        
                                        <div className={this.state.categoriaId === null ? 'div-input-disabled' : this.state.produtoClass} onClick={() => this.controllerModalProd()}>
                                                <input 
                                                    disabled={this.state.categoriaId === null ? true : false}
                                                    value={this.state.produto}
                                                    name="valor"
                                                    type="text"
                                                    required
                                                    contentEditable={false}
                                                    style={{
                                                        caretColor: 'transparent'
                                                    }}
                                                    onChange={() => {}}
                                                    />
                                                <label htmlFor="" className="label-name">
                                                    <span className="content-name">Produto</span>
                                                </label>
                                                    <button className="botao-olho">
                                                        <FiChevronDown size={22} color="#1c0506" className="i" />
                                                    </button>
                                        </div>
                                    </div>
        
                                    <button className="save" onClick={() => this.postNovidades()}>
                                        Salvar alterações
                                    </button>
                                </div>
                            ) : (
                                <div className="destaques">
                                    <h1>Combo de produtos</h1> 
        
                                    {!!this.state.combos.length
                                        ? (
                                            <h5>Você possui <span>0{this.state.combos.length} {this.state.combos.length < 2 ? "combo" : "combos"} de produtos.</span></h5>
                                        )
                                        : (
                                            <h5>Você ainda não possui nenhum combo de produtos.</h5>
                                        )
                                    }
        
                                    <div className="produtos">
                                        {!!this.state.combos.length 
                                            && ( this.state.combos.map(item => (
                                                    <div className="produto-filled">
        
                                                        <div className="left">
                                                            <img 
                                                                src={item.produto.imagem !== null ? `https://appedidos-share-private.s3.amazonaws.com/${item.produto.imagem}` : prodNoImg} 
                                                                // alt={item.produto.nome} 
                                                            />
        
                                                            <span className="name">{item.produto.nome}</span>

                                                            <div className="middle-content">
                                                                    <p>Nome</p>
                                                                    <span>{item.produto.nome}</span>
                                                            </div>
                                                        </div>
        
                                                        <div className="right">
        
                                                            <button onClick={() => this.delNovidades(item.id)}>
                                                                <FiTrash2 className="icon"/> 
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))
                                            )
                                        }

                                        <button className="adicionar" onClick={() => this.createNovidade()}>
                                            Montar combo de produtos
                                        </button>
                                    </div>
                                </div>
                            )
                    )
                }
            </Container>
        )
    }

}

const entrada = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '322px',
        height: '100%',
        maxHeight: '256px'
      }
  };

const mobile = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -42%)',
        width: '100%',
        maxWidth: '360px',
        height: '85%',
      }
  };